// import { parse as parseCookie } from 'cookie-es'
// import { getRequestHeader } from 'h3'
import { requestIdleCallback } from '#app'

export type InitStage = 'auth' | 'init1' | 'init2' | 'init3' | 'initAds' | 'nav'

export default defineNuxtPlugin({
  parallel: false,
  setup() {
    type StageNum = 0 | 1 | 2 | 3 | 4 | 5 | 6
    const stageMap: Record<InitStage, StageNum> = { auth: 1, nav: 2, init1: 3, init2: 4, init3: 5, initAds: 6 }
    const curr = useState<StageNum | -1>('initFastValue:num', () => 0)
    // -1 means do it fast

    // if (import.meta.server) {
    //   const nuxt = useNuxtApp()
    //   // if islandContext do not do slow "hidration"
    //   if (nuxtApp.ssrContext?.islandContext) curr.value = 5
    //   else {
    //     const event = useRequestEvent(nuxt)
    //     const cookieHead = event ? getRequestHeader(event, 'cookie') : undefined
    //     const cookies = cookieHead ? parseCookie(cookieHead) : undefined
    //     if (cookies && (cookies.xcsrftoken || cookies.se1 || cookies.se2 || cookies.se3)) curr.value = -1
    //   }
    // }

    onNuxtReady(() => {
      let cleanup: (() => unknown)[] = []

      const set = (next: StageNum, ms: number) => {
        const ok = () => curr.value < next
        const time = window.setTimeout(() => {
          if (ok()) {
            requestIdleCallback(() => {
              if (ok()) curr.value = next
            })
            if (next === 6) {
              cleanup.forEach((i) => i())
              cleanup = []
            }
          }
        }, ms)
        cleanup.push(() => window.clearTimeout(time))
      }

      const doneAll = (...rest: [a: number, b: number, c: number, d: number, e: number, f: number]) => rest.forEach((ms, index) => set((index + 1) as StageNum, ms))
      doneAll(10, 50, 100, 500, 3000, 5000)
      const fast = () => doneAll(10, 50, 100, 200, 300, 5000)

      // server set init fast e.g. user is auth
      // if (curr.value === -1) fast()
      // else {
      // fast()
      // doneAll(3000, 4000, 5000, 6000, 7000, 12000)
      ;(['scroll', 'mousemove', 'touchmove', 'wheel'] satisfies (keyof DocumentEventMap)[]).forEach((key) => cleanup.push(useEventListener(key, () => fast(), { once: true, passive: true })))
      // }
    })

    function initedFunc(stage: InitStage): globalThis.ComputedRef<boolean> {
      const num = stageMap[stage]
      const m = ref(false)
      onMounted(() => (m.value = true))
      return computed(() => m.value && curr.value >= num)
    }

    return { provide: { initedFunc } }
  },
})
